import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetProductionCatalogsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionCatalogDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionCatalogDocumentSortInput> | Types.ProductionCatalogDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  includeCombined?: Types.Scalars['Boolean']['input'];
}>;


export type GetProductionCatalogsQuery = { __typename?: 'Query', productionCatalogs?: { __typename?: 'ProductionCatalogsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionCatalogDocument', id: string, tenantId: string, productionCatalogId: string, genus: string, series: string, color: string, origin?: Types.ProductionCatalogOrigin | null, status: Types.ProductionCatalogStatus, combinedIntoProductionCatalogId?: string | null, combinedAt?: Types.TDateISO | null, defaultFarm?: { __typename?: 'ProductionCatalogFarmDocumentData', vendorId: string, vendorName: string } | null, alternateFarms: Array<{ __typename?: 'ProductionCatalogFarmDocumentData', vendorId: string, vendorName: string }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProductionCatalogQueryVariables = Types.Exact<{
  productionCatalogId: Types.Scalars['String']['input'];
}>;


export type GetProductionCatalogQuery = { __typename?: 'Query', productionCatalog?: { __typename?: 'ProductionCatalogData', tenantId: string, productionCatalogId: string, genus: string, series: string, color: string, origin?: Types.ProductionCatalogOrigin | null, status: Types.ProductionCatalogStatus, defaultFarm?: { __typename?: 'ProductionCatalogFarmData', vendorId: string, vendorName: string } | null, alternateFarms: Array<{ __typename?: 'ProductionCatalogFarmData', vendorId: string, vendorName: string }> } | null };

export type ProductionCatalogSummaryFragment = { __typename?: 'ProductionCatalogDocument', id: string, tenantId: string, productionCatalogId: string, genus: string, series: string, color: string, origin?: Types.ProductionCatalogOrigin | null, status: Types.ProductionCatalogStatus, combinedIntoProductionCatalogId?: string | null, combinedAt?: Types.TDateISO | null, defaultFarm?: { __typename?: 'ProductionCatalogFarmDocumentData', vendorId: string, vendorName: string } | null, alternateFarms: Array<{ __typename?: 'ProductionCatalogFarmDocumentData', vendorId: string, vendorName: string }> };

export type ProductionCatalogDataFragment = { __typename?: 'ProductionCatalogData', tenantId: string, productionCatalogId: string, genus: string, series: string, color: string, origin?: Types.ProductionCatalogOrigin | null, status: Types.ProductionCatalogStatus, defaultFarm?: { __typename?: 'ProductionCatalogFarmData', vendorId: string, vendorName: string } | null, alternateFarms: Array<{ __typename?: 'ProductionCatalogFarmData', vendorId: string, vendorName: string }> };

export type GetProductionCatalogCombinePreviewQueryVariables = Types.Exact<{
  survivorId: Types.Scalars['String']['input'];
  loserId: Types.Scalars['String']['input'];
}>;


export type GetProductionCatalogCombinePreviewQuery = { __typename?: 'Query', productionCatalogCombinePreview: { __typename?: 'ProductionCatalogCombinePreviewPayload', preview?: { __typename?: 'ProductionCatalogCombinePreview', survivorId: string, loserId: string, conflictCount: number, fields: Array<{ __typename?: 'ProductionCombineField', key: string, label: string, kind: Types.ProductionCombineFieldKind, survivorValue?: string | null, loserValue?: string | null, resultValue?: string | null, isConflict: boolean, keepBothAllowed: boolean }>, lots: { __typename?: 'ProductionCatalogCombineLots', open: number, posted: number, jobs: number, splitCategories: number, unstampedLotsOnSplits: number, postedUnstampedLotsOnSplits: number } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type GetProductionCatalogOptionsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.ProductionCatalogDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionCatalogDocumentSortInput> | Types.ProductionCatalogDocumentSortInput>;
}>;


export type GetProductionCatalogOptionsQuery = { __typename?: 'Query', productionCatalogs?: { __typename?: 'ProductionCatalogsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionCatalogDocument', productionCatalogId: string, genus: string, series: string, color: string, status: Types.ProductionCatalogStatus }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export const ProductionCatalogSummaryFragmentDoc = new TypedDocumentString(`
    fragment ProductionCatalogSummary on ProductionCatalogDocument {
  id
  tenantId
  productionCatalogId
  genus
  series
  color
  origin
  defaultFarm {
    vendorId
    vendorName
  }
  alternateFarms {
    vendorId
    vendorName
  }
  status
  combinedIntoProductionCatalogId
  combinedAt
}
    `, {"fragmentName":"ProductionCatalogSummary"});
export const ProductionCatalogDataFragmentDoc = new TypedDocumentString(`
    fragment ProductionCatalogData on ProductionCatalogData {
  tenantId
  productionCatalogId
  genus
  series
  color
  origin
  defaultFarm {
    vendorId
    vendorName
  }
  alternateFarms {
    vendorId
    vendorName
  }
  status
}
    `, {"fragmentName":"ProductionCatalogData"});
export const GetProductionCatalogsDocument = new TypedDocumentString(`
    query GetProductionCatalogs($where: ProductionCatalogDocumentFilterInput, $order: [ProductionCatalogDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String, $includeCombined: Boolean! = false) {
  productionCatalogs(
    where: $where
    order: $order
    first: $first
    last: $last
    before: $before
    after: $after
    includeCombined: $includeCombined
  ) {
    nodes {
      ...ProductionCatalogSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ProductionCatalogSummary on ProductionCatalogDocument {
  id
  tenantId
  productionCatalogId
  genus
  series
  color
  origin
  defaultFarm {
    vendorId
    vendorName
  }
  alternateFarms {
    vendorId
    vendorName
  }
  status
  combinedIntoProductionCatalogId
  combinedAt
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionCatalogDocument = new TypedDocumentString(`
    query GetProductionCatalog($productionCatalogId: String!) {
  productionCatalog(productionCatalogId: $productionCatalogId) {
    ...ProductionCatalogData
  }
}
    fragment ProductionCatalogData on ProductionCatalogData {
  tenantId
  productionCatalogId
  genus
  series
  color
  origin
  defaultFarm {
    vendorId
    vendorName
  }
  alternateFarms {
    vendorId
    vendorName
  }
  status
}`);
export const GetProductionCatalogCombinePreviewDocument = new TypedDocumentString(`
    query GetProductionCatalogCombinePreview($survivorId: String!, $loserId: String!) {
  productionCatalogCombinePreview(survivorId: $survivorId, loserId: $loserId) {
    preview {
      survivorId
      loserId
      fields {
        ...ProductionCombineFieldDetails
      }
      lots {
        open
        posted
        jobs
        splitCategories
        unstampedLotsOnSplits
        postedUnstampedLotsOnSplits
      }
      conflictCount
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionCombineFieldDetails on ProductionCombineField {
  key
  label
  kind
  survivorValue
  loserValue
  resultValue
  isConflict
  keepBothAllowed
}`);
export const GetProductionCatalogOptionsDocument = new TypedDocumentString(`
    query GetProductionCatalogOptions($first: Int, $after: String, $where: ProductionCatalogDocumentFilterInput, $order: [ProductionCatalogDocumentSortInput!]) {
  productionCatalogs(first: $first, after: $after, where: $where, order: $order) {
    nodes {
      productionCatalogId
      genus
      series
      color
      status
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetProductionCatalogs: build.query<GetProductionCatalogsQuery, GetProductionCatalogsQueryVariables | void>({
      query: (variables) => ({ document: GetProductionCatalogsDocument, variables })
    }),
    GetProductionCatalog: build.query<GetProductionCatalogQuery, GetProductionCatalogQueryVariables>({
      query: (variables) => ({ document: GetProductionCatalogDocument, variables })
    }),
    GetProductionCatalogCombinePreview: build.query<GetProductionCatalogCombinePreviewQuery, GetProductionCatalogCombinePreviewQueryVariables>({
      query: (variables) => ({ document: GetProductionCatalogCombinePreviewDocument, variables })
    }),
    GetProductionCatalogOptions: build.query<GetProductionCatalogOptionsQuery, GetProductionCatalogOptionsQueryVariables | void>({
      query: (variables) => ({ document: GetProductionCatalogOptionsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetProductionCatalogsQuery, useLazyGetProductionCatalogsQuery, useGetProductionCatalogQuery, useLazyGetProductionCatalogQuery, useGetProductionCatalogCombinePreviewQuery, useLazyGetProductionCatalogCombinePreviewQuery, useGetProductionCatalogOptionsQuery, useLazyGetProductionCatalogOptionsQuery } = injectedRtkApi;
